export const SIZE_CHART_SKU = ["KYDH107CP",
  "KYDH153CP",
  "KYDH154CP", "KYDH213CP"];
